module.exports = __webpack_public_path__ + "img/math_BG_pattern.3bd0d566.svg";